module.exports = __webpack_public_path__ + "img/left-arrow.7f0a0838.png";